/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Completed_By_LabelInputs */

const en_task_completed_by_label = /** @type {(inputs: Task_Completed_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed by`)
};

const pt_br2_task_completed_by_label = /** @type {(inputs: Task_Completed_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluída por`)
};

/**
* | output |
* | --- |
* | "Completed by" |
*
* @param {Task_Completed_By_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_completed_by_label = /** @type {((inputs?: Task_Completed_By_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Completed_By_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_completed_by_label(inputs)
	return pt_br2_task_completed_by_label(inputs)
});